exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".addresses-component{border:0;vertical-align:top;text-align:left;font-size:9pt;padding:28px 40px 40px}#content .col-1,#content .col-2{width:280px;margin-right:40px}#content .col-3{width:280px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/Addresses.css
// module id = 132
// module chunks = 0